import { Stream } from './stream';

export class PodcastSearchResult {
    public count: number;
    public nextOffset: number;
    public total: number;

    public results: Stream[];
}